import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import i18nextHttp from 'i18next-http-backend'
import getEnv from 'utilities/getEnv'

declare module 'i18next' {
    interface CustomTypeOptions {
        returnNull: false
    }
}

const web_version = getEnv('WEB_VERSION')

//also use in CFD component
i18next
    .use(initReactI18next)
    .use(i18nextHttp)
    .init({
        returnNull: false,
        lng: 'en',
        fallbackLng: 'en', // fallback lang to en if other not found
        nsSeparator: false,
        backend: {
            queryStringParams: { v: `${web_version}` },
        },
    })

export default i18next
